import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { IconButton, Button } from '@mui/material';
import { useStyles } from './style';
import { TableItemActionsNew, Icons } from 'components';
const columns = (postDefault,
  copyItem,
  formatOwners,
  actionsList,
  currentLoaction,
  handleOnEdit,
  setItemIdToDelete,
  setConfirmDeleteModal) => [
    {
      title: 'ردیف',
      field: 'num',
      filtering: false,
      sorting: false,
      align: 'center',
      cellStyle: {
        width: '1%',
      },
      headerStyle: {
        width: '1%',
      },
    },
    ...(actionsList['shebaUpdateCardPage'] ? [{
      title: 'پیش فرض',
      field: 'default',
      filtering: false,
      sorting: false,
      align: 'center',
      render: (row) => (
        <IconButton
          style={{ padding: 4 }}
          onClick={() => (!row?.default ? postDefault(row?.id) : null)}
          size="large">
          {row?.default ? (
            <Icons icon="Accept" color="#303d8f" size="25" />

          ) : (
            <Icons icon="Accept" color="#d1d8dc" size="25" />

          )}
        </IconButton>
      ),
    }] : []),
    {
      title: 'شماره شبا',
      field: 'number',
      filtering: false,
      sorting: false,
      align: 'center',
      cellStyle: {
        width: '30%',
      },
      headerStyle: {
        width: '30%',
      },
      render: (rd) => {
        if (rd?.shebaNumber) {
          return (
            <>
              <span
                style={{
                  marginInlineEnd: 8,
                  position: 'relative',
                  top: 4,
                  cursor: 'pointer',
                }}
                onClick={() => copyItem(rd?.shebaNumber)}
              >
                <Icons icon="copy" color="#d1d8dc" hover="#303d8f" size="20" />

              </span>
              <span
                style={{
                  unicodeBidi: 'embed',
                  direction: 'ltr',
                }}
              >
                {rd?.shebaNumber ? `IR-${rd?.shebaNumber}` : '-'}
              </span>

            </>
          );
        } else {
          return '-';
        }
      },
    },
    {
      title: 'عنوان حساب',
      filtering: false,
      sorting: false,
      align: 'center',
      field: 'name',
    },
    {
      title: 'نام صاحبان حساب',
      filtering: false,
      sorting: false,
      align: 'center',
      field: 'owners',
      render: (row) => (row?.owners && row?.owners?.length > 0 ? formatOwners(row.owners) : '-'),
    },
    ...((String(currentLoaction?.pathname).toUpperCase().includes('IMPREST') ? (actionsList['shebaImprestDeleteCardPage'] || actionsList['shebaImprestUpdateCardPage']) : (actionsList['shebaDeleteCardPage'] || actionsList['shebaUpdateCardPage'])) ? [{
        title: 'عملیات',
        field: 'operationSmall',
        filtering: false,
        sorting: false,
        align: 'right',
        cellStyle: {
          width: '1%',
        },
        headerStyle: {
          width: '1%',
        },
        render: (rowData) => (
          <TableItemActionsNew
            iconButton
            startIcon={<Icons icon="MoreHorizontal" color="#667585"  size="20" />}
            title=""
            otherMenus={[
              {
                title: 'ویرایش',
                isShow: !!String(currentLoaction?.pathname).toUpperCase().includes('IMPREST') ? actionsList['shebaImprestUpdateCardPage'] : actionsList['shebaUpdateCardPage'],
                onClick: () => {
                  handleOnEdit(rowData);
                },
              },
              {
                title: 'حذف',
                isShow: !!String(currentLoaction?.pathname).toUpperCase().includes('IMPREST') ? actionsList['shebaImprestDeleteCardPage'] : actionsList['shebaDeleteCardPage'],
                onClick: () => {
                  setItemIdToDelete(rowData?.id);
                  setConfirmDeleteModal(rowData);
                },
              },


            ]}
          />
        ),
      }] : []),


  ];

const SeeDetailBtn = ({ row }) => {
  return (
    <RouterLink to={`/CartableRequest/List?cartableId=${row?.multiConfirmationSrv?.id}`}>
      <Button variant="outlined" color="primary">
        درخواست ها
      </Button>
      <Button variant="outlined" color="primary">
        درخواست ها
      </Button>
    </RouterLink>
  );
};
const StatusConfirm = ({ row }) => {
  return (
    <div style={{ display: 'flex', justifyContent: 'center' }}>
      {row.map((item, index) => {
        return `${status[item]}  ${index != row.length - 1 ? ' - ' : ''}`;
      })}
    </div>
  );
};

const DefaultComponent = ({ rd, postDefault }) => {
  const classes = useStyles();

  return (
    <>
      <IconButton
        className={classes.setDefaultButton}
        onClick={() => (!rd?.default ? postDefault(rd?.id) : null)}
        size="large">
        {row?.default ? (
          <Icons icon="Accept" color="#303d8f" size="25" />

        ) : (
          <Icons icon="Accept" color="#d1d8dc" size="25" />

        )}
      </IconButton>
    </>
  );
};

const status = {
  MULTI_CONFIRMATION_VERIFY_TOOL_SMS: 'پیامک',
  MULTI_CONFIRMATION_VERIFY_TOOL_API: 'سرویس',
};
const generateData = (rows, query) => {
  return rows?.map?.((row, key) => ({
    num: query?.page * query?.pageSize + key + 1,
    ...row,
  }));
};

export { columns, generateData };
